import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import api from './api';
import rootReducer from './reducers';

const configureStore = () => {
  const middlewares = [thunk, api];

  const store = createStore(
    rootReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
    applyMiddleware(...middlewares)
  );

  if (process.env.NODE_ENV !== "production") {
    if (module.hot) {
      module.hot.accept("./reducers", () => {
        store.replaceReducer(rootReducer)
      })
    }
  }

  return store
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/configureStore.js